// extracted by mini-css-extract-plugin
export default {"box":"Dashboard_box__HrQdJ","navigation":"Dashboard_navigation__4ShyC","border":"Dashboard_border__GAyzM"};